import angular from 'angular';
import AuthenticationService from './authentication.service';

let authenticationModule = angular.module('authentication', []).service('AuthenticationService', AuthenticationService);

export default authenticationModule;



// WEBPACK FOOTER //
// ./app/common/authentication/authentication.js